/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringHealthStatus } from './ScoringHealthStatus';
import {
    ScoringHealthStatusFromJSON,
    ScoringHealthStatusFromJSONTyped,
    ScoringHealthStatusToJSON,
    ScoringHealthStatusToJSONTyped,
} from './ScoringHealthStatus';

/**
 * 
 * @export
 * @interface ScoringHealthClientResponse
 */
export interface ScoringHealthClientResponse {
    /**
     * 
     * @type {ScoringHealthStatus}
     * @memberof ScoringHealthClientResponse
     */
    status: ScoringHealthStatus;
    /**
     * The live gameplay DataSource the board accepts, when GREEN.
     * @type {string}
     * @memberof ScoringHealthClientResponse
     */
    source?: string;
    /**
     * A live gameplay DataSource the board does NOT accept, when that is why it is RED. The surface words this itself.
     * @type {string}
     * @memberof ScoringHealthClientResponse
     */
    unscoredSource?: string;
    /**
     * Player-facing reason, present when RED with no live client at all.
     * @type {string}
     * @memberof ScoringHealthClientResponse
     */
    reason?: string;
}



/**
 * Check if a given object implements the ScoringHealthClientResponse interface.
 */
export function instanceOfScoringHealthClientResponse(value: object): value is ScoringHealthClientResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ScoringHealthClientResponseFromJSON(json: any): ScoringHealthClientResponse {
    return ScoringHealthClientResponseFromJSONTyped(json, false);
}

export function ScoringHealthClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringHealthClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': ScoringHealthStatusFromJSON(json['status']),
        'source': json['source'] == null ? undefined : json['source'],
        'unscoredSource': json['unscoredSource'] == null ? undefined : json['unscoredSource'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function ScoringHealthClientResponseToJSON(json: any): ScoringHealthClientResponse {
    return ScoringHealthClientResponseToJSONTyped(json, false);
}

export function ScoringHealthClientResponseToJSONTyped(value?: ScoringHealthClientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ScoringHealthStatusToJSON(value['status']),
        'source': value['source'],
        'unscoredSource': value['unscoredSource'],
        'reason': value['reason'],
    };
}

